export const useLineChartStyles = () => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        },
        title: {
            color: 'white',
            fontWeight: 500
        },
        chartContainer: {
            position: 'relative',
            flexGrow: 1
        },
        centerContent: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center'
        },
        centerText: {
            color: 'white',
            fontWeight: 400,
            fontSize: '24px'
        },
        centerSubtext: {
            color: 'rgba(255, 255, 255, 0.7)'
        },
        legend: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: 1,
            mt: 2
        },
        legendItem: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
        legendColor: {
            width: 12,
            height: 12,
            borderRadius: '50%'
        },
        legendText: {
            color: 'white',
            fontSize: '0.875rem'
        }
    };
};
